import React from "react"
import { useLocation, br } from "react-router-dom"
import { AdminRoutes as menuAdminRoutes } from "../../routes/index"
import ManejeBemLogo from "../../assets/img/ManejeBemLogo.png"
import { ArrowBack } from "../ImageComponents"
import { Button } from "../Button"
import { NavHome, UserMenu } from "../Navigation"
import { PageName } from "../PageName"
import { IoIosArrowForward } from "react-icons/io"
import { IoClose } from "react-icons/io5"
import { NotificationMenu } from "../NotificationMenu"
import { createContext, useContext, useState } from "react";
const pageHeadersContext = createContext([null, () => { }]);
import { useEffect } from "react";
import "./styles.scss"

export const Header = ({ navigate }) => {
  return (
    <header className="main-page-header">
      <Logo companyImage={ManejeBemLogo} />
      <NavHome navigate={navigate} />
      <UserMenu userName="Karolina Victória" userImage={userImage} />
    </header>
  )
}

export const HeaderTwo = ({ titlePage, labelButton, hasIcon, children, logo, goBack }) => {
  return (
    <header className="main-page-header header-two">
      <div className="header-two--left">
        <Logo companyImage={logo || ManejeBemLogo} />
        <TitlePage title={titlePage} hasIcon={hasIcon} />
      </div>
      <div className="header-two--right">
        {children && children}
        {goBack && (
          <Button color="orange" label={labelButton} handleClick={goBack} hasIcon={<ArrowBack />} />
        )}
      </div>
    </header>
  )
}

export const Logo = ({ companyImage }) => {
  return (
    <div className="header-logo">
      <img src={companyImage} alt="Logo da Empresa Manejebem" />
    </div>
  )
}

export const TitlePage = ({ title, hasIcon }) => {
  return (
    <>
      <div className="title-page">
        <div className="title-page__content">
          <div className="title-page__content-icon">{hasIcon && hasIcon}</div>
          <h2 className="title-page__content-name">{title}</h2>
        </div>
      </div>
    </>
  )
}

export const HeaderNav = ({ children }) => {
  const { pathname, state } = useLocation()
  const page = menuAdminRoutes().filter((item) => item.path.includes(pathname.split("/")[1]))[0]

  const noHeader = state?.hiddenHeader || page?.hiddenHeader

  return (
    <>
      {noHeader ? <></> : <header className="header-nav">
        {children ? (
          <>
            <div className="header-nav__left">
              <PageName icon={page?.icon} name={page?.name} />
            </div>
            <div className="header-nav__right">
              {children}
            </div>
          </>
        ) : (
          <>
            <div className="header-nav__left">
              {page?.name === "ESM" ? (
                <HeaderESM page={page} />
              ) : (
                <PageName icon={page?.icon} name={page?.name} />
              )}
            </div>
            <div className="header-nav__right">
              {page?.name === "Beneficiários" && <NotificationMenu />}
            </div>
          </>
        )}
      </header>}
    </>
  )
}

export const HeaderNavContent = () => {
  const [element] = usePageHeader();

  return (
    <HeaderNav children={element} />
  )
}

const HeaderESM = ({ page }) => {

  return (
    <div className="header-row">
      <PageName icon={page?.icon} name={page?.name} />
      <IoIosArrowForward className="icon-arrow" />
      {/* <SelectInput
      defaultValue={selectESM}
      placeholder="Selecione a Tag"
      onChange={(value) => {
        dispatch(setData({ selectESM: value }))
      }}
      options={[{ value: 0, label: "Escala" }, { value: 1, label: "Produtores" }, { value: 2, label: "Planejamento" }]}
    /> */}
    </div>
  )
}

export const HeaderContent = ({ children, className, ...props }) => {
  return (
    <div className={`header-content${className ? " " + className : ""}`} {...props}>
      {children}
    </div>
  )
}

export const HeaderCardESM = ({ title, goBack, children, styles }) => {
  return (
    <HeaderContent className="esm-header">
      <h1>{title}</h1>
      <div className="esm-header-buttons" style={children ? { justifyContent: "space-between", gap: "20px" } : styles}>
        {children}
        {goBack && <div className="button-close" onClick={() => goBack()}>
          <IoClose size={28} />
        </div>}
      </div>
    </HeaderContent>
  )
}

export const HeaderCard = ({ title, goBack, children, styles }) => {
  return (
    <HeaderContent className="esm-header">
      <h1>{title}</h1>
      <div className="esm-header-buttons" style={children ? { justifyContent: "flex-end", gap: "20px" } : styles}>
        {!goBack && children}
        {goBack && <div className="button-close" onClick={() => goBack()}>
          <IoClose size={28} />
        </div>}
      </div>
    </HeaderContent>
  )
}

export const CardTitleContent = ({ title, goBack, children, styles }) => {
  return (
    <HeaderContent className="esm-header">
      <h1>{title}</h1>
      <div className="esm-header-buttons" style={children ? { justifyContent: "flex-end", gap: "20px" } : styles}>
        {!goBack && children}
        {goBack && <div className="button-close" onClick={() => goBack()}>
          <IoClose size={28} />
        </div>}
      </div>
    </HeaderContent>
  )
}

export function PageHeaderProvider({ children }) {
  const [element, setElement] = useState();
  const location = useLocation();

  useEffect(() => {
    setElement(null)
  }, [location])

  return (
    <pageHeadersContext.Provider value={[element, setElement]}>
      {children}
    </pageHeadersContext.Provider>
  );
}

export function usePageHeader() {
  return useContext(pageHeadersContext);
}

export function PageHeaderAddon({ children, removeElement = false }) {
  const [, setElement] = usePageHeader();

  useEffect(() => {
    if (removeElement) {
      setElement(null)
    }
    else {
      setElement(children)
    }
  }, [children, setElement, removeElement]);

  return null;
}

